import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4 gy-5 mb-90" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "edit-profile-inner" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-wrapper" }, [
      /*#__PURE__*/_createElementVNode("ul", {
        class: "nav nav-tabs",
        id: "myTab",
        role: "tablist"
      }, [
        /*#__PURE__*/_createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link active",
            id: "home-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#home",
            type: "button",
            role: "tab",
            "aria-controls": "home",
            "aria-selected": "true"
          }, [
            /*#__PURE__*/_createElementVNode("span"),
            /*#__PURE__*/_createTextVNode("Basic Information:")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            id: "profile-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#profile",
            type: "button",
            role: "tab",
            "aria-controls": "profile",
            "aria-selected": "false"
          }, [
            /*#__PURE__*/_createElementVNode("span"),
            /*#__PURE__*/_createTextVNode("Profile")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            id: "contact-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#contact",
            type: "button",
            role: "tab",
            "aria-controls": "contact",
            "aria-selected": "false"
          }, [
            /*#__PURE__*/_createElementVNode("span"),
            /*#__PURE__*/_createTextVNode("Education")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            id: "professional-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#professional",
            type: "button",
            role: "tab",
            "aria-controls": "professional",
            "aria-selected": "false"
          }, [
            /*#__PURE__*/_createElementVNode("span"),
            /*#__PURE__*/_createTextVNode("Professional Info")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "tab-content",
        id: "myTabContent"
      }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "home",
          role: "tabpanel",
          "aria-labelledby": "home-tab"
        }, [
          /*#__PURE__*/_createElementVNode("form", { class: "edit-profile-form profile-form mb-60" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "firstname1" }, "First Name*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/user-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "firstname1",
                      name: "firstname",
                      placeholder: "Mrs. Jacoline"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-4 col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, "Last Name*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/user-2.svg ",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "lastname",
                      name: "lastname",
                      placeholder: "Frankly"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-xxl-2 col-lg-12 position-relative" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "drag-area" }, [
                  /*#__PURE__*/_createElementVNode("p", null, "Upload Images"),
                  /*#__PURE__*/_createElementVNode("button", {
                    type: "button",
                    class: "upload-btn"
                  }, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" })
                  ]),
                  /*#__PURE__*/_createElementVNode("input", {
                    type: "file",
                    hidden: ""
                  })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "jobplace" }, "Current Job Place*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/company-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "jobplace",
                      name: "jobplace",
                      placeholder: "Company Name"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "desigation" }, "Designation*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/designation-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "desigation",
                      name: "desigation",
                      placeholder: "UI/UX Engineer"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "experiences" }, "Year of Experiences*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/experiences-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "experiences",
                      name: "experiences",
                      placeholder: "3.5 Years"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", null, "Qualification*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/qualification-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                      /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Bachelor Degree in CSE"),
                      /*#__PURE__*/_createElementVNode("option", { value: "1" }, "IGCSE"),
                      /*#__PURE__*/_createElementVNode("option", { value: "2" }, "AS"),
                      /*#__PURE__*/_createElementVNode("option", { value: "4" }, "A Level"),
                      /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Matriculated")
                    ])
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "email1" }, "Email*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/email-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "email1",
                      name: "email",
                      placeholder: "info@example.com"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "phonenumber" }, "Phone Number*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/phone-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "phonenumber",
                      name: "phonenumber",
                      placeholder: "+880-17 *** *** **"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "website" }, "Website Link*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/website-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "website",
                      name: "website",
                      placeholder: "https://example.com"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "language" }, "Language*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/language-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "language",
                      name: "language",
                      placeholder: "Bangla, English, Hindi"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-50" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Career Objective*"),
                  /*#__PURE__*/_createElementVNode("textarea", {
                    name: "description",
                    id: "description",
                    placeholder: "Something Write Yourself...."
                  })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner" }, [
                  /*#__PURE__*/_createElementVNode("button", {
                    class: "primry-btn-2 lg-btn w-unset",
                    type: "submit"
                  }, "Update Resume")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "form-wrapper" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
              /*#__PURE__*/_createElementVNode("h5", null, "Social Network:")
            ]),
            /*#__PURE__*/_createElementVNode("form", { class: "profile-form" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "fecebook" }, "Facebook"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/facebook-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "fecebook",
                        name: "fecebook",
                        placeholder: "https://example-fecebook.com"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "twitter" }, "Twitter"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/twiter-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "twitter",
                        name: "twitter",
                        placeholder: "https://example-twitter.com"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "linkedin" }, "LinkedIn"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/linkedin-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "linkedin",
                        name: "linkedin",
                        placeholder: "https://example-linkedin.com"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "pinterest" }, "Pinterest"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/pinterest-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "pinterest",
                        name: "pinterest",
                        placeholder: "https://example-pinterest.com"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "dribble" }, "Dribbble"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/dribble-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "dribble",
                        name: "dribble",
                        placeholder: "https://example-dribbble.com"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-50" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "behance" }, "Behance"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/behance-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "behance",
                        name: "behance",
                        placeholder: "https://example-behance.com"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner" }, [
                    /*#__PURE__*/_createElementVNode("button", {
                      class: "primry-btn-2 lg-btn w-unset",
                      type: "submit"
                    }, "Update Social Link")
                  ])
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "profile",
          role: "tabpanel",
          "aria-labelledby": "profile-tab"
        }, [
          /*#__PURE__*/_createElementVNode("form", { class: "edit-profile-form profile-form" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "fathername" }, "Father’s Name*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/user-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "fathername",
                      name: "fathername",
                      placeholder: "Mr. Norman Frankly"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "mothername" }, "Mother's Name*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/user-2.svg ",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "mothername",
                      name: "mothername",
                      placeholder: "Mrs. Marcoline Frankly"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "datepicker5" }, "Date of Birth*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/calender2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "datepicker5",
                      name: "datepicker5",
                      placeholder: "03/08/1986"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "nid" }, "National Id*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/nid.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "nid",
                      name: "nid ",
                      placeholder: "0988 *** *** *** **"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "salary-wrap" }, [
                    /*#__PURE__*/_createElementVNode("label", {
                      class: "label",
                      for: "preAddress"
                    }, "Present Address*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "checkbox-container" }, [
                      /*#__PURE__*/_createElementVNode("ul", null, [
                        /*#__PURE__*/_createElementVNode("li", null, [
                          /*#__PURE__*/_createElementVNode("label", { class: "containerss" }, [
                            /*#__PURE__*/_createElementVNode("input", { type: "checkbox" }),
                            /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }),
                            /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Same as permanent Address")
                          ])
                        ])
                      ])
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/home-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "preAddress",
                      name: "preAddress ",
                      placeholder: "Your Address Here..."
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "perAddress" }, "Permanent Address*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/home-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "perAddress",
                      name: "perAddress",
                      placeholder: "Your Address Here..."
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", null, "Marital Status*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/marital-2.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                      /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Single"),
                      /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Married"),
                      /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Widowed"),
                      /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Divorced")
                    ])
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", null, "Gender*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/gender.svg ",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                      /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Female"),
                      /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Male"),
                      /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Custom")
                    ])
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", null, "Religion*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/religion.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                      /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Christianity"),
                      /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Islam"),
                      /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Buddhism"),
                      /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Sikhism"),
                      /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Judaism")
                    ])
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", null, "Blood Group*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/blood.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                      /*#__PURE__*/_createElementVNode("option", { value: "0" }, "A+"),
                      /*#__PURE__*/_createElementVNode("option", { value: "1" }, "A-"),
                      /*#__PURE__*/_createElementVNode("option", { value: "2" }, "B+"),
                      /*#__PURE__*/_createElementVNode("option", { value: "3" }, "B-"),
                      /*#__PURE__*/_createElementVNode("option", { value: "4" }, "AB+"),
                      /*#__PURE__*/_createElementVNode("option", { value: "5" }, "AB-"),
                      /*#__PURE__*/_createElementVNode("option", { value: "6" }, "O+"),
                      /*#__PURE__*/_createElementVNode("option", { value: "7" }, "O-")
                    ])
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "hight" }, "Height*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/hight.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "hight",
                      name: "hight",
                      placeholder: "5.6'"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                  /*#__PURE__*/_createElementVNode("label", { for: "weight" }, "Weight*"),
                  /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "assets/images/icon/weight.svg",
                      alt: ""
                    }),
                    /*#__PURE__*/_createElementVNode("input", {
                      type: "text",
                      id: "weight",
                      name: "weight ",
                      placeholder: "56"
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "skills-row" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "section-title2 mb-20" }, [
                      /*#__PURE__*/_createElementVNode("h5", null, "Your Skills:")
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                      /*#__PURE__*/_createElementVNode("label", null, "Special Skills*"),
                      /*#__PURE__*/_createElementVNode("select", {
                        class: "js-example-basic-multiple",
                        name: "states[]",
                        multiple: "multiple"
                      })
                    ])
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "form-inner" }, [
                  /*#__PURE__*/_createElementVNode("button", {
                    class: "primry-btn-2 lg-btn w-unset",
                    type: "submit"
                  }, "Update Change")
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "contact",
          role: "tabpanel",
          "aria-labelledby": "contact-tab"
        }, [
          /*#__PURE__*/_createElementVNode("form", { class: "edit-profile-form profile-form" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
              /*#__PURE__*/_createElementVNode("h5", null, "Educational Qualification:")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "education-row" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
                    /*#__PURE__*/_createElementVNode("h6", null, "Academic Information:"),
                    /*#__PURE__*/_createElementVNode("div", { class: "dash" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", null, "Education Level*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/qualification-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                        /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Bachelor Degree in CSE"),
                        /*#__PURE__*/_createElementVNode("option", { value: "1" }, "IGCSE"),
                        /*#__PURE__*/_createElementVNode("option", { value: "2" }, "AS"),
                        /*#__PURE__*/_createElementVNode("option", { value: "4" }, "A Level"),
                        /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Matriculated")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", null, "My Major*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/major.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                        /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Science"),
                        /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Arts")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "institute" }, "Institute/University*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/univercity.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "institute",
                        name: "institute",
                        placeholder: "Type Your Institute Name..."
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-30" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "gpa" }, "Result/GPA**"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/gpa-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "gpa",
                        name: "gpa",
                        placeholder: "4.75/5"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-20" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "datepicker10" }, "Starting Period*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/calender2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "datepicker10",
                        name: "ep",
                        placeholder: "DD/MM/YY"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-20" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "datepicker11" }, "Ending Period*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/calender2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "datepicker11",
                        name: "ep",
                        placeholder: "DD/MM/YY"
                      })
                    ])
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "add-remove-btn d-flex align-items-center justify-content-between mb-50" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "add-row" }, [
                /*#__PURE__*/_createElementVNode("button", {
                  type: "button",
                  class: "add-education-row"
                }, "Add Education+")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "form-inner" }, [
                /*#__PURE__*/_createElementVNode("button", {
                  class: "primry-btn-2 lg-btn w-unset",
                  type: "submit"
                }, "Update Change")
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "professional",
          role: "tabpanel",
          "aria-labelledby": "professional-tab"
        }, [
          /*#__PURE__*/_createElementVNode("form", { class: "edit-profile-form profile-form" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
              /*#__PURE__*/_createElementVNode("h5", null, "Employment Information:")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "experiences-row" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
                    /*#__PURE__*/_createElementVNode("h6", null, "Add Your Experiences"),
                    /*#__PURE__*/_createElementVNode("div", { class: "dash" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "companies" }, "Company Name*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/company-2.svg ",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "companies",
                        name: "companies",
                        placeholder: "Egenslab"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-25" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "desigation" }, "Designation*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/designation-2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("select", { class: "select1" }, [
                        /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Back-end developer"),
                        /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Front-end developer"),
                        /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Full-stack developer")
                      ])
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-20" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "datepicker6" }, "Starting Period*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/calender2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "datepicker6",
                        name: "stp",
                        placeholder: "DD/MM/YY"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-20" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "datepicker7" }, "Ending Period*"),
                    /*#__PURE__*/_createElementVNode("div", { class: "input-area" }, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: "assets/images/icon/calender2.svg",
                        alt: ""
                      }),
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "text",
                        id: "datepicker7",
                        name: "ep",
                        placeholder: "DD/MM/YY"
                      })
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-agreement employment-check form-inner d-flex justify-content-between flex-wrap p-0" }, [
                    /*#__PURE__*/_createElementVNode("div", { class: "form-group two" }, [
                      /*#__PURE__*/_createElementVNode("input", {
                        type: "checkbox",
                        id: "html5"
                      }),
                      /*#__PURE__*/_createElementVNode("label", { for: "html5" }, "Continuing Working Here")
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "form-inner mb-20" }, [
                    /*#__PURE__*/_createElementVNode("label", { for: "description1" }, "Responsibility**"),
                    /*#__PURE__*/_createElementVNode("textarea", {
                      name: "description",
                      id: "description1",
                      placeholder: "Write Your Responsibility..."
                    })
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "add-remove-btn d-flex align-items-center justify-content-between mb-50" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "add-row" }, [
                /*#__PURE__*/_createElementVNode("button", {
                  type: "button",
                  class: "add-experiences-row"
                }, "Add New+ ")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "form-inner" }, [
                /*#__PURE__*/_createElementVNode("button", {
                  class: "primry-btn-2 lg-btn w-unset",
                  type: "submit"
                }, "Update Change")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_menu = _resolveComponent("user-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_user_menu),
        _hoisted_4
      ])
    ])
  ]))
}